import { PropsWithChildren } from 'react';

import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface RemoveSensitiveMarkConfirmationModalProps extends PropsWithChildren {
  isOpen: boolean;
  onConfirm: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

const TOP_LEVEL_ID = 'sensitive-group-class-confirmation';

const RemoveSensitiveMarkConfirmationModal = ({
  isOpen,
  onConfirm,
  setIsOpen,
}: RemoveSensitiveMarkConfirmationModalProps) => {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel`}
            leftIcon={FAIconName.XmarkRegular}
            onClick={handleClose}
            variant="secondary"
          >
            Cancel
          </FireflyButton>

          <FireflyButton
            id={`${TOP_LEVEL_ID}__confirm`}
            leftIcon={FAIconName.checkRegular}
            onClick={() => {
              onConfirm();
            }}
            variant="accent.critical"
          >
            Remove sensitive status
          </FireflyButton>
        </ChakraFlex>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={handleClose}
      size="lg"
      title="Confirm change to group privacy"
    >
      <ChakraFlex flexDirection="column" gap="20px">
        <Text
          color="neutral.primary"
          id={`${TOP_LEVEL_ID}__subtitle`}
          variant="body"
        >
          Removing the sensitive flag for this group will expose the
          registration status of current registrants to their proxy supports.
          Patients registering for a sensitive class have an expectation of
          privacy, and this change will remove that protection.
          <br />
          <br />
          If you are unsure of the privacy settings for this group, please
          cancel and mark this group as sensitive.
        </Text>
      </ChakraFlex>
    </ModalV2>
  );
};

export default RemoveSensitiveMarkConfirmationModal;
